import "@styles/app.sass"
import { initializeClock } from "./partials/count-down";
import { Modal, ModalOpener } from "./partials/modal";
import Rellax from "rellax"

document.addEventListener("DOMContentLoaded", () => {
    initializeClock('[data-event-countdown]');

    if (document.querySelector('[data-parallax]')) {
        new Rellax('[data-parallax]', {
            center: true
        })
    }

    (() => { // Hiding header
        const header = document.querySelector('[data-page-header]') as HTMLElement
        if (!header) return

        const headerOffset = header.offsetTop - window.scrollY,
            headerHeight = (header.children[0] as HTMLElement)?.offsetHeight ?? 0

        let lastScroll = 0

        const hidingOnScroll = () => {
            const currentScroll = window.scrollY

            if (currentScroll > headerOffset + headerHeight) {
                header.classList.add('is-sticked')
                header.classList[currentScroll > lastScroll ? 'add' : 'remove']('is-up')
                document.body.classList[currentScroll > lastScroll ? 'remove' : 'add']('is-sticked-header')
            } else {
                header.classList.remove('is-sticked')
                header.classList.remove('is-up')
                document.body.classList.remove('is-sticked-header')
            }

            lastScroll = currentScroll
        }

        hidingOnScroll()
        window.addEventListener('scroll', () => hidingOnScroll(), { passive: true })

        const navOpener = document.querySelector('[data-nav-opener]')
        navOpener.addEventListener("click", () => {
            document.body.classList.toggle('u-hiddenOverflow')
            navOpener.closest('[data-page-header]')?.classList.toggle('is-opened')
        })
    })();

    (() => { // Speaker modal
        new Modal("#Modal-speakerDetail")
        document.querySelectorAll('[data-modal-opener]')
            .forEach((el: HTMLElement) => new ModalOpener(el))
    })();

    (() => { // Stage + Day tab switching
        const stageTabs = Array.from(document.querySelectorAll<HTMLButtonElement>('[data-stage-tab]'))
        const dayTabs   = Array.from(document.querySelectorAll<HTMLButtonElement>('[data-day-tab]'))
        const dayPanels = Array.from(document.querySelectorAll<HTMLElement>('[data-day-panel]'))

        if (!dayTabs.length) return

        let activeDay   = 0
        let activeStage = stageTabs[0]?.dataset.stageTab ?? ''

        const updateView = () => {
            // Day panels: show only active
            dayPanels.forEach((panel, i) => {
                panel.classList.toggle('is-hidden', i !== activeDay)
            })
            dayTabs.forEach((tab, i) => {
                const active = i === activeDay
                tab.classList.toggle('is-active', active)
                tab.setAttribute('aria-selected', active ? 'true' : 'false')
            })

            // Stage tabs: highlight active
            stageTabs.forEach(tab => {
                const active = tab.dataset.stageTab === activeStage
                tab.classList.toggle('is-active', active)
                tab.setAttribute('aria-selected', active ? 'true' : 'false')
            })

            // Filter entries in active panel by stage
            const activePanel = dayPanels[activeDay]
            if (!activePanel) return
            activePanel.querySelectorAll<HTMLElement>('.EventProgramEntry[data-stage]').forEach(entry => {
                const entryStage = entry.dataset.stage ?? ''
                // Empty stage = shared (breaks, lunch) — always visible
                entry.classList.toggle('is-hidden', entryStage !== '' && entryStage !== activeStage)
            })
        }

        // Init
        updateView()

        dayTabs.forEach((tab, i) => {
            tab.addEventListener('click', () => { activeDay = i; updateView() })
        })

        stageTabs.forEach(tab => {
            tab.addEventListener('click', () => {
                activeStage = tab.dataset.stageTab ?? ''
                updateView()
            })
        })
    })();
})